import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries/incidence-types/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries/incidence-types/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries/incidence-types/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/incidence-types/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/incidence-types/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/incidence-types/delete/${id}`)
    },
}